var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingsDatabase = function SvgSettingsDatabase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    "data-name": "Layer 1",
    viewBox: "0 -8 72 72"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 4.07c-11.85 0-21.46 3.21-21.46 7.19v5.89c0 4 9.61 7.19 21.46 7.19s21.45-3.21 21.45-7.19v-5.89c.01-3.98-9.6-7.19-21.45-7.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 27.78c-11.32 0-20.64-2.93-21.46-6.66v9.75c0 4 9.61 7.18 21.46 7.18s21.45-3.21 21.45-7.18v-9.75c-.82 3.73-10.13 6.66-21.45 6.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.44 35c-.82 3.72-10.12 6.66-21.43 6.66S15.37 38.72 14.55 35v9.75c0 4 9.61 7.18 21.46 7.18s21.45-3.21 21.45-7.18Z"
  }))));
};
export default SvgSettingsDatabase;